var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightblue05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 100",
    style: {
      enableBackground: "new 0 0 70 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#183D71;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#4C708B;}\r\n\t.st3{fill:#A7CBF0;}\r\n\t.st4{fill:#D4B653;}\r\n\t.st5{fill:#BA8A5E;}\r\n\t.st6{fill:#6F3D37;}\r\n\t.st7{fill:#667352;}\r\n\t.st8{fill:#9BA658;}\r\n\t.st9{fill:#0F3F2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35,1.9c-18.8,0-34,15.2-34,34s34,62.1,34,62.1s34-43.3,34-62.1S53.8,1.9,35,1.9z M35,58.8 c-12.6,0-22.9-10.2-22.9-22.9c0-12.6,10.2-22.9,22.9-22.9s22.9,10.2,22.9,22.9C57.9,48.6,47.6,58.8,35,58.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35,
    cy: 35.9,
    r: 22.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.2,36.3c3.2-1.6,5.3-4.8,5.3-8.5c0-5.2-4.3-9.5-9.5-9.5s-9.5,4.3-9.5,9.5c0,3.7,2.1,7,5.3,8.5 c-4.7,1.7-7.2,5.8-8,13.2c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h23.3c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.2,0.1-0.4 C46.4,42.1,43.9,38,39.2,36.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue05);
export default __webpack_public_path__ + "static/media/lightblue05.bf4ade3e785a7408e8912287764d995a.svg";
export { ForwardRef as ReactComponent };